import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CurrentLanguage from '@/components/CurrentLanguage.vue';
import MediaList from '@/components/media/MediaList.vue';
import { Initiative } from '@/models/initiative.model';
import { UserLabel } from '@/models/label.model';
import { MediaPurpose } from '@/models/media.model';
import {
  Story,
  StoryType,
  titleRules,
  notificationCTARules,
} from '@/models/story.model';
import { useEvents, Event } from '@/services/events.composable';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { ContentStoreActions, ContentStoreState } from '@/stores/content.store';
import { LabelsState } from '@/stores/labels.store';
import { StoriesActions, StoriesState } from '@/stores/stories.store';
import { NEW_ID } from '@/util/constants';
import { computed, onMounted, PropType, ref, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import CategoryField from '../categories/CategoryField.vue';
import CategoriesField from '../categories/CategoriesField.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'StoryForm',
  props: {
  data: {
    type: Object as PropType<Story>,
  },
},
  setup(__props) {

const store = useStore<
  ShiftCMSState & {
    ts: StoriesState;
    ls: LabelsState;
    cns: ContentStoreState;
  }
>();
const events = useEvents();
const stories = computed<Story[]>(() => store.state.ts.stories);
const initiatives = computed<Initiative[]>(() => store.state.cns.initiatives);
const labels = computed<UserLabel[]>(() => store.state.ls.labels);

const props = __props;

const valid = ref<boolean>(false);

const story = ref<Story>({
  id: NEW_ID,
  title: '',
  notificationCTA: '',
  type: StoryType.Quiz,
  index: stories.value.length,
  items: [],
  notRelevantForlabels: [],
  published: false,
  media: [],
  categories: [],
  initiativeOfTheDay: null,
});

const action = computed<string>(() =>
  story.value.id === NEW_ID ? 'Add' : 'Save',
);

const saveStory = async () => {
  let success: boolean = false;
  if (valid.value) {
    if (story.value.id === NEW_ID) {
      success = await store.dispatch(StoriesActions.AddStory, story.value);
    } else {
      success = await store.dispatch(StoriesActions.UpdateStory, story.value);
    }
  }
  if (success) {
    events.emit(Event.Saved, true);
    store.dispatch(Actions.ShowNotification, {
      message: 'Saved story',
      type: 'success',
    });
    store.commit(Mutations.HideDrawer);
    store.dispatch(StoriesActions.GetStories);
  }
};

const updateLanguage = async () => {
  if (story.value.id === NEW_ID) {
    Object.assign(story.value, { title: '', type: 'story' });
  } else {
    const cat = await store.dispatch(StoriesActions.GetStory, story.value.id);

    if (cat) {
      Object.assign(story.value, { ...cat });
    }
  }
};

onMounted(() => {
  events.on(Event.LanguageChanged, updateLanguage);
  store.dispatch(ContentStoreActions.GetInitiatives);
  if (props.data) {
    Object.assign(story.value, props.data);
  }
});

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, updateLanguage);
});

const types = [
  {
    title: 'Quiz',
    value: 'quiz',
  },
  {
    title: 'Story',
    value: 'story',
  },
];

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: valid.value,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((valid).value = $event)),
    onSubmit: _withModifiers(saveStory, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, [
            _createTextVNode(_toDisplayString(_ctx.$t(action.value)) + " a story ", 1),
            _createVNode(CurrentLanguage)
          ]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: story.value.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((story.value.title) = $event)),
                    rules: _unref(titleRules),
                    label: "Title",
                    required: ""
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(CategoryField, {
                    main: "",
                    modelValue: story.value.mainCategory,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((story.value.mainCategory) = $event)),
                    disabled: "",
                    label: "Main Category"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: story.value.type,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((story.value.type) = $event)),
                    items: types,
                    label: "Type",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(CategoriesField, {
                    modelValue: story.value.categories,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((story.value.categories) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: story.value.notificationCTA,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((story.value.notificationCTA) = $event)),
                    rules: _unref(notificationCTARules),
                    label: "Notification message",
                    hint: "This text will be used to remind users of this quiz. It has a maximum length of 150",
                    required: "",
                    counter: ""
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_select, {
            modelValue: story.value.notRelevantForlabels,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((story.value.notRelevantForlabels) = $event)),
            label: "Not relevant for labels",
            multiple: "",
            clearable: "",
            class: "mt-4",
            "hide-details": "auto",
            style: { background: 'white' },
            items: labels.value.map((q) => ({ title: q.value, value: q }))
          }, {
            item: _withCtx(({ props }) => [
              _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title)
                ]),
                _: 2
              }, 1040)
            ]),
            _: 1
          }, 8, ["modelValue", "items"]),
          _createVNode(_component_v_select, {
            modelValue: story.value.initiativeOfTheDay,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((story.value.initiativeOfTheDay) = $event)),
            label: "Initiative of the day",
            clearable: "",
            class: "mt-4",
            "hide-details": "auto",
            style: { background: 'white' },
            items: initiatives.value.map((q) => ({ text: q.title, value: q }))
          }, {
            item: _withCtx(({ props }) => [
              _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title)
                ]),
                _: 2
              }, 1040)
            ]),
            _: 1
          }, 8, ["modelValue", "items"]),
          _createVNode(MediaList, {
            modelValue: story.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((story).value = $event)),
            required: [_unref(MediaPurpose).BackgroundImage]
          }, null, 8, ["modelValue", "required"]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { col: "2" }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "reset",
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("Reset")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "submit",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { col: "2" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})